import { setAlertDetails } from "api";
import moment from "moment";
import CryptoJS from "crypto-js";
import momentT from "moment-timezone";
import AvatarWithIcon from "components/global/AvatarWithIcon";

export const OCCUPATIONS = [
  "Content Creator",
  "Influencer",
  "Social media manager",
  "Digital marketer",
  "Entrepreneur",
  "Marketing agency",
  "Other",
];

export const USAGE_INTENTIONS = [
  "I want to automate posting on multiple social media",
  "I want to analyze insights from all my social accounts",
  "I want to collaborate with my team",
  "I want PostPaddy to assist in content creation",
  "Other",
];

export const INDUSTRIES = [
  "Accounting",
  "Airlines/Aviation",
  "Alternative Dispute Resolution",
  "Alternative Medicine",
  "Animation",
  "Apparel & Fashion",
  "Architecture & Planning",
  "Arts and Crafts",
  "Automotive",
  "Aviation & Aerospace",
  "Banking",
  "Biotechnology",
  "Broadcast Media",
  "Building Materials",
  "Business Supplies and Equipment",
  "Capital Markets",
  "Chemicals",
  "Civic & Social Organization",
  "Civil Engineering",
  "Commercial Real Estate",
  "Computer & Network Security",
  "Computer Games",
  "Computer Hardware",
  "Computer Networking",
  "Computer Software",
  "Construction",
  "Consumer Electronics",
  "Consumer Goods",
  "Consumer Services",
  "Cosmetics",
  "Dairy",
  "Defense & Space",
  "Design",
  "Digital Marketing",
  "E-Learning",
  "Education Management",
  "Electrical/Electronic Manufacturing",
  "Energy",
  "Entertainment",
  "Environmental Services",
  "Events Services",
  "Executive Office",
  "Facilities Services",
  "Farming",
  "Financial Services",
  "Fine Art",
  "Fishery",
  "Food & Beverages",
  "Food Production",
  "Fund-Raising",
  "Furniture",
  "Gambling & Casinos",
  "Glass, Ceramics & Concrete",
  "Government Administration",
  "Government Relations",
  "Graphic Design",
  "Health, Wellness and Fitness",
  "Higher Education",
  "Horticulture",
  "Hospital & Health Care",
  "Hospitality",
  "Human Resources",
  "Import and Export",
  "Individual & Family Services",
  "Industrial Automation",
  "Information Services",
  "Information Technology and Services",
  "Insurance",
  "International Affairs",
  "International Trade and Development",
  "Internet",
  "Investment Banking",
  "Investment Management",
  "Judiciary",
  "Law Enforcement",
  "Law Practice",
  "Legal Services",
  "Legislative Office",
  "Leisure, Travel & Tourism",
  "Libraries",
  "Logistics and Supply Chain",
  "Luxury Goods & Jewelry",
  "Machinery",
  "Management Consulting",
  "Maritime",
  "Market Research",
  "Marketing and Advertising",
  "Mechanical or Industrial Engineering",
  "Media Production",
  "Medical Devices",
  "Medical Practice",
  "Mental Health Care",
  "Military",
  "Mining & Metals",
  "Mobile Games",
  "Motion Pictures and Film",
  "Museums and Institutions",
  "Music",
  "Nanotechnology",
  "Newspapers",
  "Non-Profit Organization Management",
  "Online Media",
  "Outsourcing/Offshoring",
  "Package/Freight Delivery",
  "Packaging and Containers",
  "Paper & Forest Products",
  "Performing Arts",
  "Pharmaceuticals",
  "Philanthropy",
  "Photography",
  "Plastics",
  "Political Organization",
  "Primary/Secondary Education",
  "Printing",
  "Professional Training & Coaching",
  "Program Development",
  "Public Policy",
  "Public Relations and Communications",
  "Public Safety",
  "Publishing",
  "Railroad Manufacture",
  "Ranching",
  "Real Estate",
  "Recreational Facilities and Services",
  "Religious Institutions",
  "Renewables & Environment",
  "Research",
  "Restaurants",
  "Retail",
  "Security and Investigations",
  "Semiconductors",
  "Shipbuilding",
  "Social Media Management",
  "Sporting Goods",
  "Sports",
  "Staffing and Recruiting",
  "Supermarkets",
  "Telecommunications",
  "Textiles",
  "Think Tanks",
  "Tobacco",
  "Translation and Localization",
  "Transportation/Trucking/Railroad",
  "Utilities",
  "Venture Capital & Private Equity",
  "Veterinary",
  "Warehousing",
  "Wholesale",
  "Wine and Spirits",
  "Wireless",
  "Writing and Editing",
  "Other",
];

export const BUSINESS_TYPES = [
  "Business to Business (B2B)",
  "Business to Customer (B2C)",
];

export const fbTestEmail = [
  "mojeedeji16@gmail.com",
  "natashadibie@gmail.com",
  "ernestizic9@gmail.com",
  "demo@postpaddy.com",
  "ibukun@digifigs.com",
  "jroberts@yopmail.com",
  "tuna@yopmail.com",
  "djokershub@gmail.com",
  "info@digifigs.com",
];

export const formDataToJSON = (formData) => {
  let object = {};

  formData.forEach((value, key) => {
    // Reflect.has in favor of: object.hasOwnProperty(key)
    if (!Reflect.has(object, key)) {
      object[key] = value;
      return;
    }
    if (!Array.isArray(object[key])) {
      object[key] = [object[key]];
    }
    object[key].push(value);
  });

  return object;
};

export const parseJSON = (str) => JSON.parse(str);

export const parseDate = (d) => Date.parse(d);

export const getFormattedTime = (timestamp) => {
  let unix_timestamp = timestamp;

  let date = new Date(parseInt(unix_timestamp));
  // Hours part from the timestamp
  let hours =
    "0" + (date.getHours() > 12 ? date.getHours() - 12 : date.getHours());
  // Minutes part from the timestamp
  let minutes = "0" + date.getMinutes();

  let formattedTime;

  // Will display time in 10:30 am format
  if (date.getHours() >= 12) {
    formattedTime = hours.slice(-2) + ":" + minutes.slice(-2) + " pm";
  } else {
    formattedTime = hours.slice(-2) + ":" + minutes.slice(-2) + " am";
  }

  return formattedTime;
};

export const getFormattedDate = (timestamp, tomorrow = false) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  let unix_timestamp = timestamp;

  let date = new Date(parseInt(unix_timestamp));

  let month = monthNames[date.getMonth()];

  let day = "0" + date.getDate();

  let year = new Date(parseInt(unix_timestamp)).toLocaleString("en-US", {
    year: "numeric",
  });

  let formattedDate;

  if (tomorrow) {
    day = "0" + (date.getDate() + 1);
    formattedDate = day.substr(-2) + " " + month + " " + year;
  } else {
    formattedDate = day.substr(-2) + " " + month + " " + year;
  }

  return formattedDate;
};

export const isOnline = () => {
  return window.navigator.onLine;
};

export const greyFilter =
  "brightness(0%) saturate(100%) invert(93%) sepia(0%) saturate(326%) hue-rotate(139deg) brightness(84%) contrast(93%);";

export function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach((key) => {
    let val = object[key];
    if (typeof val === "object") {
      val = JSON.stringify(val);
    }
    formData.append(key, val);
  });
  return formData;
}

/**
 * @example
 * // Example usage:
 * showAlert({
 *   msg: "Competitor added successfully!",
 *   type: "success | danger",
 * });
 *
 * @example
 * // Ensure <AlertBox /> is rendered in your component tree:
 * ```
 * <AlertBox />
 * ```
 */
export const showAlert = (details) => {
  setAlertDetails(details);

  setTimeout(() => setAlertDetails(null), 7000);
};

export const media_base_url =
  "https://postpaddy-s.fra1.digitaloceanspaces.com/Postpaddy";

export function isToday(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();

  return (
    d.getDate() === today.getDate() &&
    d.getMonth() === today.getMonth() &&
    d.getFullYear() === today.getFullYear()
  );
}

export function isTomorrow(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();
  const tomorrow = new Date(today.setDate(today.getDate() + 1));

  return (
    d.getDate() === tomorrow.getDate() &&
    d.getMonth() === tomorrow.getMonth() &&
    d.getFullYear() === tomorrow.getFullYear()
  );
}

export function isLater(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();
  const tomorrow = new Date(today.setDate(today.getDate() + 1));

  return d.getTime() > tomorrow.getTime();
}

export function isYesterday(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();
  const yesterday = new Date(today.setDate(today.getDate() - 1));

  return (
    d.getDate() === yesterday.getDate() &&
    d.getMonth() === yesterday.getMonth() &&
    d.getFullYear() === yesterday.getFullYear()
  );
}

export function isOlder(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();
  const yesterday = new Date(today.setDate(today.getDate() - 1));

  return d.getTime() < yesterday.getTime();
}

export function isSameDay(d1, d2) {
  if (!d1 || !d2) return;

  const d = new Date(parseInt(d1));
  const current = new Date(d2);

  return (
    d.getDate() === current.getDate() &&
    d.getMonth() === current.getMonth() &&
    d.getFullYear() === current.getFullYear()
  );
}

export const getFileSize = (size) => {
  return size < 1000
    ? `${size.toFixed(1)} b`
    : size > 1000 && size < 1000 * 1000
    ? `${(size / 1000).toFixed(1)} KB`
    : `${(size / 1000 / 1000).toFixed(1)} MB`;
};

export const isValidUrl = (url) => {
  // eslint-disable-next-line
  const urlRegex =
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
  return urlRegex.test(url);
};

export const formatHashtagAndMention = (
  text,
  urlList,
  handleUnshorten,
  fetchedUser,
  handleUpdateContent,
  activePlatform,
  setTagInfo,
  dropdownRef,
  user
) => {
  let formattedText = [];
  const retLines = text?.split("\n");

  var format = /[ !#@$%^&*()_+\-=[\]{};':"\\|,.<>/?\n]/;

  retLines?.forEach((retLine, lineIndex) => {
    const words = retLine.split(" ");
    const contentLength = words.length;

    if (lineIndex !== 0) formattedText.push(<br />);
    let wordIndex = 0;

    while (wordIndex < contentLength) {
      const word = words[wordIndex];
      const isShortened = urlList?.find((item) => item.shortUrl === word);

      let openDropdown = false;
      let styledWords = [];
      let tagFound = false;

      if (word.startsWith("@") && !format.test(word.substr(1))) {
        openDropdown = true;

        // Check for multi-word tags
        for (let i = wordIndex; i < words.length; i++) {
          const potentialTag = words.slice(wordIndex, i + 1).join(" ");
          const user = fetchedUser?.find(
            (data) =>
              data.name.toLowerCase() ===
              potentialTag.toLowerCase().substring(1)
          );

          if (user) {
            styledWords = words.slice(wordIndex, i + 1);
            tagFound = true;
            wordIndex = i; // Update wordIndex to skip the processed words
            break;
          }
        }
      }

      if (
        tagFound ||
        (word.startsWith("@") && !format.test(word.substr(1))) ||
        (word.startsWith("#") && !format.test(word.substr(1))) ||
        isValidUrl(word)
      ) {
        if (!tagFound) {
          styledWords = [word];
        }

        const mention = (
          <span
            key={`${word}${wordIndex}`}
            className={`highlighted ${openDropdown ? "dropdownContainer" : ""}`}
            onClick={() => {
              if (dropdownRef.current) {
                dropdownRef.current.style.display = "block"; // Show dropdown on click
              }
            }}
          >
            {styledWords.join(" ")}
            {openDropdown &&
              styledWords.join(" ").substring(1) &&
              activePlatform === "facebook" &&
              fbTestEmail.includes(user.email) && (
                <div ref={dropdownRef} className="dropdown">
                  {fetchedUser &&
                    fetchedUser
                      ?.filter((data) =>
                        data.name
                          .toLowerCase()
                          .includes(
                            styledWords.join(" ").toLowerCase().substring(1)
                          )
                      )
                      ?.map((data) => (
                        <div
                          key={data.name}
                          className="dropdownContent cursorPointer"
                          onClick={() => {
                            let newWord = `@${data.name}`;
                            const newText = text.replace(
                              styledWords.join(" "),
                              newWord
                            );
                            const newData = {
                              [`@[${data.page_id}]`]: data.name,
                            };
                            setTagInfo((prev) => ({ ...prev, ...newData }));
                            handleUpdateContent("caption", newText);
                            if (dropdownRef.current) {
                              dropdownRef.current.style.display = "none";
                            }
                          }}
                        >
                          <AvatarWithIcon
                            className="avatar"
                            social="facebook"
                            avatar={data?.profile_picture}
                            size={4.0}
                          />
                          <div className="contentBody">
                            <p>{data.name}</p>
                            <div>
                              {data.username && <p>@{data.username} .</p>}
                              <p>{data.followers} follow this</p>
                            </div>
                          </div>
                        </div>
                      ))}
                </div>
              )}

            {isValidUrl(word) && handleUnshorten && (
              <div className="unshorten-tooltip">
                <button
                  className={`tooltiptext ${
                    !isShortened ? "button-hidden" : ""
                  }`}
                  id={`index${word}_url`}
                  onClick={() => handleUnshorten(word)}
                >
                  Unshorten
                </button>
              </div>
            )}
          </span>
        );

        if (wordIndex !== contentLength - 1) {
          formattedText.push(mention, " ");
        } else {
          formattedText.push(mention);
        }

        // Skip the words that are part of the multi-word tag
        if (tagFound) {
          wordIndex += styledWords.length - 2;
        }
      } else {
        if (wordIndex !== contentLength - 1) formattedText.push(word, " ");
        else formattedText.push(word);
      }

      wordIndex++;
    }
  });

  return formattedText;
};

export const mediaIsImage = (path) => /\.(jpe?g|png|gif|bmp|heic)$/i.test(path);
export const mediaIsVideo = (path) => /\.(mp4|mov)$/i.test(path);

export const arrayToFriendlyString = ([...array]) => {
  return array.concat(array.splice(-2, 2).join(" and ")).join(", ");
};

export const formatNumber = (num) => {
  const formatter = new Intl.NumberFormat();
  const toNum = Number(num);

  return formatter.format(toNum);
};

export const toggleModalVisibility = (selector) => {
  if (typeof selector !== "string") return;

  document.querySelector(selector)?.classList.toggle("show");
};

export const capitalizeFirstLetter = (str) => {
  if (typeof str !== "string") return "";

  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const cloneObj = (obj) => JSON.parse(JSON.stringify(obj));

export const getISODate = (d) => (d ? d.toISOString().split("T")[0] : "");

export const getTimeAgo = (utc_date) => {
  if (!utc_date) return "";

  const d = Date.now();
  const d_notification = Date.parse(utc_date);
  const diff = d - d_notification;
  const years = Math.floor(diff / (12 * 30 * 24 * 60 * 60 * 1000));
  const months = Math.floor(diff / (30 * 24 * 60 * 60 * 1000));
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor(diff / (60 * 60 * 1000));
  const mins = Math.floor(diff / (60 * 1000));
  const secs = Math.floor(diff / 1000);

  if (years >= 1) {
    return `${years} ${years > 1 ? "years" : "year"} ago`;
  } else if (months >= 1) {
    return `${months} ${months > 1 ? "months" : "month"} ago`;
  } else if (days >= 1) {
    return `${days} ${days > 1 ? "days" : "day"} ago`;
  } else if (hours >= 1) {
    return `${hours} ${hours > 1 ? "hours" : "hour"} ago`;
  } else if (mins >= 1) {
    return `${mins} ${mins > 1 ? "mins" : "min"} ago`;
  } else if (secs >= 1) {
    return `${secs} ${secs > 1 ? "seconds" : "second"} ago`;
  }

  return "now";
};

export const getLocaleDateTime = (d) =>
  new Date(d).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

export const extractEmails = (text = "") => {
  return decodeURIComponent(text).match(
    /([+a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi
  );
};

export const checkLinkType = async (linkUrl, cb) => {
  try {
    const response = await fetch(linkUrl, { method: "HEAD" });
    const contentType = response.headers.get("Content-Type");

    if (contentType?.includes("video")) {
      cb("video");
    } else if (contentType?.includes("image")) {
      cb("image");
    } else {
      cb("error");
    }
  } catch (error) {
    console.error("An error occurred:", error);
    cb("error");
  }
};

export const roundNumber = (value, precision = 10) => {
  if (!value) return 0;
  return Math.round(value * precision) / precision;
};

export const generateHMAC = (message, secretKey) => {
  // Convert the secret key and message to WordArray objects
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const data = CryptoJS.enc.Utf8.parse(message);

  // Generate the HMAC using SHA-256
  const hmac = CryptoJS.HmacSHA256(data, key);

  // Convert the HMAC to a hexadecimal string
  const hmacHex = hmac.toString(CryptoJS.enc.Hex);

  return hmacHex;
};

/**
 *
 * @param {string} startDate start date
 * @param {string} endDate end date
 * @returns the difference between the start date and the end date
 */
export const getDateDifference = (startDate, endDate) => {
  const start = moment(startDate);
  const end = moment(endDate);
  return end.diff(start, "days");
};

/**
 *
 * @param {number} num Array size
 * @returns
 */
export const getNumArray = (num) => {
  const arr = [];

  for (let i = 0; i < num; i++) {
    arr[i] = i;
  }

  return arr;
};

/**
 *
 * @param {string} text text string to be truncated
 * @param {number} cutOff number of characters before truncating
 * @returns string
 */
export const truncateText = (text, cutOff) => {
  return text?.length >= cutOff ? `${text?.substring(0, cutOff)}...` : text;
};

export const platformNameMap = {
  facebook: "Facebook",
  youtube: "YouTube",
  twitter: "X (Twitter)",
  linkedin: "LinkedIn",
  instagram: "Instagram",
  tiktok: "TikTok",
  meta_threads: "Threads",
  pinterest: "Pinterest",
};

export const planTypeMap = {
  free: 1,
  essential: 2,
  growth: 3,
  agency: 4,
};

export const queryParamsHelper = (qp) => {
  let queryParam = "&";
  for (let [key, value] of Object.entries(qp || {})) {
    if (Array.isArray(value) && value.length) {
      queryParam += `${key}=[${value.join(", ")}]&`;
    } else if (!!value && value.length) {
      queryParam += `${key}=${value}&`;
    }
  }

  return queryParam?.substring(0, queryParam?.length - 1);
};

/**
 *
 * @param {number} offset Passing no arguments returns the todays date, pass 1 return the tomorrow date.
 * @returns returns date relative to today depending on the offset passed in arguments
 */
export function getDateRelativeToToday(offset = 0) {
  const today = new Date();
  const targetDate = new Date(today);
  targetDate.setDate(today.getDate() + offset);

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, "0");
  const day = String(targetDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export async function getImageDimensions(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = function () {
      resolve({
        width: img.width,
        height: img.height,
      });
    };

    img.onerror = function () {
      reject("Failed to load image");
    };

    img.src = url;
  });
}

export async function getVideoDimensions(videoUrl) {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");

    // Once metadata is loaded, get dimensions
    video.onloadedmetadata = function () {
      // Ensure metadata is available
      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
        length: video.duration,
      });
    };

    // Handle any loading errors
    video.onerror = function () {
      reject("Failed to load video");
    };

    // Set the source URL and start loading
    video.src = videoUrl;
    video.load();
  });
}

export function getAspectRatio(width, height) {
  // Calculate the greatest common divisor (GCD) using Euclid's algorithm
  const gcd = function (a, b) {
    return b === 0 ? a : gcd(b, a % b);
  };

  // Find the GCD of width and height
  const divisor = gcd(width, height);

  // Calculate aspect ratio
  const aspectRatioWidth = width / divisor;
  const aspectRatioHeight = height / divisor;

  // Return aspect ratio as a string
  return {
    aspectRatioWidth: aspectRatioWidth,
    aspectRatioHeight: aspectRatioHeight,
    aspectRatioValue: aspectRatioWidth / aspectRatioHeight,
  };
}

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// convert rbg color to hex
export const rgbToHex = (r, g, b) => {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};

//return time from timestamp
export function getTimeFromTimestamp(timestamp, timezone) {
  return momentT.tz(timestamp, timezone).format("hh:mm A");
}

// attatch temporary IDs to objects in array
export const attachIdsToContent = (contents) =>
  contents.map((c, i) => ({ id: btoa(i), ...c }));

// Function to calculate the difference in days between two dates
const differenceInDays = (date1, date2) => {
  const diffTime = Math.abs(date2 - date1);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

// Function to group media objects by date range
export const groupByDateRange = (accumulator, media) => {
  const currentDate = new Date();
  const mediaDate = new Date(media?.created_at);
  const todayStart = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  if (mediaDate >= todayStart) {
    accumulator.today.push(media);
  } else {
    const daysDifference = differenceInDays(currentDate, mediaDate);

    if (daysDifference <= 7) {
      accumulator.last7days.push(media);
    } else if (daysDifference <= 30) {
      accumulator.lastMonth.push(media);
    } else if (daysDifference <= 60) {
      accumulator.last2Months.push(media);
    } else {
      accumulator.moreThan2Months.push(media);
    }
  }

  return accumulator;
};

export const getDraftDate = (schedule_date) => {
  const d = moment.unix(schedule_date);
  const isDatePast = moment(d?._d).isBefore(Date.now());

  if (isDatePast) {
    return "Overdue";
  }

  let date = `Scheduled: ${moment(d?._d).format("lll")}`;
  return date;
};

export const convertToQueryString = (params) => {
  const queryString = Object.keys(params)
    .map((key) => {
      const value = params[key];
      if (Array.isArray(value)) {
        // Convert array to the desired format
        return `${encodeURIComponent(key)}=[${value
          .map((item) => encodeURIComponent(item))
          .join(", ")}]`;
      } else {
        // Convert other types to string and encode
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      }
    })
    .join("&");

  return `?${queryString}`;
};

export const colorArray = [
  "#EAA7D5",
  "#15AD05",
  "#CEFF35",
  "#0519B2",
  "#73476E",
  "#E44398",
  "#E3D16B",
  "#FC2DCB",
  "#79DAB9",
  "#DE2F7F",
  "#C26038",
  "#C058DA",
  "#3539DE",
  "#DF4D36",
  "#EB557E",
  "#2FE75B",
  "#26AD3B",
  "#2107C2",
  "#4D2877",
  "#511F11",
];

/**
 * Formats a given date into a human-readable string.
 *
 * The function returns a string representing how long ago the given date was
 * from the current date. It handles various ranges such as "Today", "X days ago",
 * "1 week ago", "X weeks ago", "1 month ago", "X months ago", and the actual date
 * if it is older than a year.
 *
 * @param {string|Date|moment.Moment} date - The date to format. Can be a string, Date object, or moment object.
 * @returns {string} - A human-readable string representing the time difference between the given date and now.
 */
export const formatDateValue = (date) => {
  const now = moment();
  const inputDate = moment(date);

  const diffDays = now.diff(inputDate, "days");
  const diffWeeks = now.diff(inputDate, "weeks");
  const diffMonths = now.diff(inputDate, "months");

  if (diffDays === 0) {
    return "Today";
  } else if (diffDays === 1) {
    return "1 day ago";
  } else if (diffDays < 7) {
    return `${diffDays} days ago`;
  } else if (diffWeeks === 1) {
    return "1 week ago";
  } else if (diffWeeks < 4) {
    return `${diffWeeks} weeks ago`;
  } else if (diffMonths === 1) {
    return "1 month ago";
  } else if (diffMonths < 12) {
    return `${diffMonths} months ago`;
  } else {
    return inputDate.format("Do MMMM YYYY");
  }
};

export const isEqual = (a, b) => {
  if (a === b) return true;
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!isEqual(a[i], b[i])) return false;
    }
    return true;
  }
  if (a && b && typeof a === "object" && typeof b === "object") {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA) {
      if (!isEqual(a[key], b[key])) return false;
    }
    return true;
  }
  return false;
};

export const getObjKeyByValue = (obj, value) => {
  return Object.keys(obj).find((key) => obj[key] === value);
};
